import { createContext, useContext } from 'react';

export const RedirectForceContext = createContext(null);

export const useRedirectForceContext = () => useContext(RedirectForceContext);
